import React from 'react'
import useCinemaColorsAndIcons from '../hooks/useCinemaColorsAndIcons'
import getCinemaStyles from '../functions/getCinemaStyles'

const SandwichElementTitle = ({title, cinemas}) => {
    const cinemaColorSettings = useCinemaColorsAndIcons()
    const {cinemaColor} = getCinemaStyles(cinemaColorSettings, cinemas)
    
    if(!title) {
        return ''
    }
    const style = cinemaColor ? {
        background: cinemaColor,
    } : {}

    
    return <div style={style} className="custom-slider-title"><span className="title-slider">{title}</span></div>
}  

export default SandwichElementTitle